import {EducationPhase} from '../types/enums';
import CRUDService from './CRUDService';

export interface ChecklistItem {
  _id: string;
  name: string;
  rewardAllotmentUnit?: string;
  rewardText: string;
  actionItemUrl: string | null; // | null; for my own sanity, will put back later if needed
  new?: boolean;
  completed?: boolean;
  noLongerEarnable?: boolean;
}

export interface ChecklistGroupShape {
  _id: string;
  name: string;
  current?: boolean;
  active?: boolean;
  items: ChecklistItem[];
}

export interface ChecklistShape {
  _id: string;
  educationPhase: EducationPhase;
  groups: ChecklistGroupShape[];
}

class ChecklistService extends CRUDService<ChecklistShape> {}
export default new ChecklistService('/v1/checklists');
